import { useFetch } from "../lib/useData";
import { PageHero, Section, Placeholder } from "../components/public/PublicLayout";

const HERO = "https://images.unsplash.com/photo-1665003725647-3ae0f01140b1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

function ContentBlock({ title, body }) {
  return (
    <div className="prose-stone max-w-3xl">
      <h2 className="font-display text-2xl md:text-3xl font-bold text-stone-900">{title}</h2>
      <p className="text-stone-600 text-lg leading-relaxed mt-4 whitespace-pre-line">{body}</p>
    </div>
  );
}

const PH = "This section will carry temple-approved content. The final text, historical facts and spiritual descriptions will be supplied and approved by the temple management before publishing. The information shown here is placeholder text for layout purposes only.";

export function AboutUs() {
  return (
    <div>
      <PageHero title="About Us" subtitle="Sri Mehandipur Balaji Mandir, Rajarajeshwari Nagar, Bengaluru" image={HERO} />
      <Section className="grid md:grid-cols-3 gap-10">
        <div className="md:col-span-2"><ContentBlock title="Welcome to our spiritual home" body={PH} /></div>
        <aside className="bg-amber-50 border border-amber-200 rounded-2xl p-6 h-fit">
          <h3 className="font-display font-bold text-lg text-stone-900">Quick Facts</h3>
          <ul className="mt-4 space-y-3 text-sm text-stone-600">
            <li>📍 Rajarajeshwari Nagar, Bengaluru</li>
            <li>🪔 14 deities & sacred idols</li>
            <li>🐄 Gaushala & Gau Seva</li>
            <li>🎉 13-day Annual Utsav</li>
          </ul>
        </aside>
      </Section>
    </div>
  );
}

export function History() {
  return (
    <div>
      <PageHero title="Temple History" image={HERO} />
      <Section><ContentBlock title="The history of our temple" body={PH} /></Section>
    </div>
  );
}

export function Origin() {
  return (
    <div>
      <PageHero title="Origin & Connection with Mehandipur Balaji" image={HERO} />
      <Section><ContentBlock title="Our connection with Mehandipur Balaji" body={PH} /></Section>
    </div>
  );
}

export function Journey() {
  const { data } = useFetch("/public/journey");

  // display_order ke hisaab se sort: 1, 2, 4 ... (gap ho to koi dikkat nahi)
  const milestones = [...(data || [])].sort(
    (a, b) =>
      (Number(a.display_order) || 0) - (Number(b.display_order) || 0)
  );

  return (
    <div>
      <PageHero title="Our Journey" subtitle="Milestones that shaped our temple" image={HERO} />
      <Section>
        <div className="relative max-w-3xl mx-auto">
          <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-0.5 bg-amber-300" />
          <div className="space-y-12" data-testid="journey-timeline">
          {milestones.map((m, i) => (
              <div key={m.id} className={`relative flex flex-col md:flex-row gap-6 ${i % 2 ? "md:flex-row-reverse" : ""}`}>
                <div className="md:w-1/2 pl-12 md:pl-0 md:px-8">
                  <div className={`bg-white rounded-2xl border border-amber-200 shadow-sm overflow-hidden ${i % 2 ? "md:ml-auto" : ""}`}>
                    {m.image && <img src={m.image} alt={m.title} className="w-full h-44 object-cover" />}
                    <div className="p-5">
                      <div className="font-display text-2xl font-extrabold text-orange-700">{m.year}</div>
                      <h3 className="font-bold text-lg text-stone-900 mt-1">{m.title}</h3>
                      <p className="text-sm text-stone-600 mt-2">{m.description}</p>
                    </div>
                  </div>
                </div>
                <div className="absolute left-4 md:left-1/2 top-4 -translate-x-1/2 w-4 h-4 rounded-full bg-orange-600 ring-4 ring-amber-100" />
              </div>
            ))}
          </div>
        </div>
      </Section>
    </div>
  );
}
